export default __webpack_public_path__ + "static/media/standard.0f9dec7b.svg";